module.exports = __webpack_public_path__ + "media/teacher/components/GetStarted/images/login-9f3fef98bc71931e0740627a6ea9d752.png";